import { Flex, Segmented } from 'antd'
import { FormInstance } from 'antd/lib'
import { useState } from 'react'

import { QuestionResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { AnswerCard } from './components'
import { useStyles } from './components/AnswerCard/styles'

type Props = {
  form?: FormInstance
}

export const Preview = ({ form }: Props) => {
  const { currentLang } = useLocales()
  const [previewLang, setPreviewLang] = useState(currentLang?.value)

  const { styles } = useStyles()

  const quiz = form?.getFieldsValue(true)

  return (
    <Flex vertical gap={64} justify="center" align="center">
      <Flex
        gap={8}
        className={styles.questionWrapper}
        justify="space-between"
        align="center"
      >
        <Text className={styles.quizTitle} weight={700}>
          {quiz?.[`${previewLang}Title`]}
        </Text>

        <Segmented
          options={['ro', 'ru']}
          value={previewLang}
          onChange={setPreviewLang}
          className={styles.languageSwitcher}
        />
      </Flex>

      <Flex vertical gap={48} align="start" className={styles.questionWrapper}>
        {quiz?.questions?.map((question: QuestionResponse, index: string) => (
          <Flex
            key={question?.id}
            vertical
            gap={16}
            align="start"
            className={styles.questionWrapper}
          >
            <Text className={styles.questionTitle}>
              {index + 1}. {question?.text?.[previewLang]}
            </Text>

            <AnswerCard
              questionIndex={index}
              question={question}
              form={form}
              previewLang={previewLang}
            />
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
